module.exports = __webpack_public_path__ + "static/logo_black-c12eadcd4dde87ae8a4c97c851447d31.png";